import { useContext } from 'react';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';

import { IProps } from '../../interfaces/components/link.interface';

import { ModalContext } from '../../contexts/Modal';
import { SelectionsContext } from '../../contexts/Selections';
import SvgImage from '../SvgImage';

const Link = (props: IProps) => {
  const {
    className, id, newTab, path, text, textIconAdornment, action,
  } = props;

  const selectionsContext = useContext(SelectionsContext);
  const pathValues: Record<string, string | undefined> = {
    vehicleToPair: selectionsContext?.vehicleToPair?.virtualKeyUrl,
  };
  const modalContext = useContext(ModalContext);
  const actionMap: Record<string, () => void> = {
    advanceToCheckingVirtualKey: () => {
      if (modalContext) {
        modalContext.openModal('checkingVirtualKey');
      }
    },
    openBluetoothSettings: () => {
      if (
        modalContext
        && modalContext.context
        && modalContext.context.openBluetoothSettings
      ) {
        (modalContext.context as { openBluetoothSettings: () => void })
          .openBluetoothSettings();
      }
    },
  };
  const handleClick = () => {
    if ((action && actionMap[action])) {
      actionMap[action]();
    }
  };

  let openingAttributes = {};

  if (newTab) {
    openingAttributes = {
      target: '_blank',
      rel: 'noreferrer noopener',
    };
  }

  const getText = () => {
    if (textIconAdornment) {
      return (
        <div className="flex align-center justify-center">
          <span>{text}</span>
          <SvgImage name={textIconAdornment} containerClassNames="m-l-xs icon" />
        </div>
      );
    }

    return text;
  };

  const classNameAndId = {
    className: clsx('link', className),
    id,
  };

  return path.startsWith('/') ? (
    <RouterLink
      to={path}
      {...classNameAndId}
      onClick={handleClick}
    >
      {getText()}
    </RouterLink>
  ) : (
    <a
      href={pathValues[path] || path}
      onClick={handleClick}
      {...classNameAndId}
      {...openingAttributes}
    >
      {getText()}
    </a>
  );
};

Link.defaultProps = {
  newTab: true,
};

export default Link;
